import React from 'react';
import { ClipboardCheck, Wallet, Clock } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const SpotEarningsSummary = ({ reservations = [], transfers = [] }) => {
  const { t } = useTranslation();
  
  // Calculate totals
  const totalEarned = transfers
    .filter(t => t.status === 'completed')
    .reduce((sum, t) => sum + t.points, 0);

  //pending are all the reservations that are status: active
  const pendingEarnings = reservations
    .filter(r => r.status === 'active')
    .reduce((sum, r) => sum + r.points_cost, 0);

  return (
    <div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
        {/* Total Earned Card */}
        <div className="flex items-start space-x-4 p-4 rounded-lg bg-green-500/5 border border-green-500/10">
          <div className="p-2 rounded-full bg-green-500/10">
            <Wallet className="h-5 w-5 text-green-500" />
          </div>
          <div>
            <p className="text-sm font-medium text-muted-foreground">{t('parking.earnings.totalEarned')}</p>
            <p className="text-2xl font-bold text-green-500">
              {totalEarned} {t('parking.earnings.points')}
            </p>
            <p className="text-xs text-muted-foreground mt-1">{t('parking.earnings.completedTransfers')}</p>
          </div>
        </div>

        {/* Pending Earnings Card */}
        <div className="flex items-start space-x-4 p-4 rounded-lg bg-blue-500/5 border border-blue-500/10">
          <div className="p-2 rounded-full bg-blue-500/10">
            <Clock className="h-5 w-5 text-blue-500" />
          </div>
          <div>
            <p className="text-sm font-medium text-muted-foreground">{t('parking.earnings.pending')}</p>
            <p className="text-2xl font-bold text-blue-500">
              {pendingEarnings} {t('parking.earnings.points')}
            </p>
            <p className="text-xs text-muted-foreground mt-1">{t('parking.earnings.toBeReceived')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpotEarningsSummary;